import clsx from 'clsx';
import React, { forwardRef } from 'react';
import Icon from './Icon';

const Input = forwardRef(
  ({ label, wrapperClassName, icon, iconOnClick, ...props }, ref) => {
    return (
      <div className={clsx('input__wrapper', wrapperClassName)}>
        {label && (
          <label htmlFor={props.id} className="input__label">
            {label}
            {props.required && '*'}
          </label>
        )}

        {/* ✅ Wrap input and icon in a relative container */}
        <div className="input__field-wrapper">
          <input
            className={clsx('input', icon && 'input--with-icon')}
            {...props}
            ref={ref}
          />
          {icon && (
            iconOnClick ? (
              <button
                type="button"
                className="input__icon-wrapper input__icon-wrapper--button"
                onClick={iconOnClick}
              >
                <Icon name={icon} size={24} className="input__icon" />
              </button>
            ) : (
              <div className="input__icon-wrapper input__icon-wrapper--not-button">
                <Icon name={icon} size={24} className="input__icon" />
              </div>
            )
          )}
        </div>
      </div>
    );
  }
);

export default Input;
